module.exports = "/static/assets/14f9d56d55436cf7fad1167a0261f318.png";